import { render, staticRenderFns } from "./AvatarPreview.vue?vue&type=template&id=07dd052f&"
import script from "./AvatarPreview.vue?vue&type=script&lang=js&"
export * from "./AvatarPreview.vue?vue&type=script&lang=js&"
import style0 from "./AvatarPreview.vue?vue&type=style&index=0&id=07dd052f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports